import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Observer } from "gsap/Observer";
import "./SwiperUp.css"; // Add relevant styles

gsap.registerPlugin(ScrollTrigger, Observer);

const SwiperUp = ({ children }) => {
  const containerRef = useRef(null);
  const curIndex = useRef(0); // Tracks the current section index

  useEffect(() => {
    const sections = containerRef.current.querySelectorAll(".scroll-section");

    sections.forEach((section, i) => {
      const thisTrigger = section.querySelector("h2");

      // Master timeline for each section
      const masterTL = gsap.timeline({
        paused: true,
        onComplete: () => {
          scrollObserver.disable();
          curIndex.current = i + 1; // Update the index to allow the next section
        },
      });

      masterTL.to(thisTrigger, { color: "red", duration: 0.5 });
      masterTL.to(thisTrigger, { color: "orange", duration: 0.5 });
      masterTL.to(thisTrigger, { color: "yellow", duration: 0.5 });
      masterTL.to(thisTrigger, { color: "black", duration: 0.5 });

      // Scroll observer to freeze and play the timeline
      const scrollObserver = Observer.create({
        type: "wheel,touch",
        wheelSpeed: -1,
        debounce: false,
        dragMinimum: 2,
        preventDefault: true,
        onUp: () => masterTL.play(),
        onEnable(self) {
          const savedScroll = self.scrollY();
          self._restoreScroll = () => self.scrollY(savedScroll);
          document.addEventListener("scroll", self._restoreScroll, { passive: false });
        },
        onDisable(self) {
          document.removeEventListener("scroll", self._restoreScroll);
        },
      });

      scrollObserver.disable();

      // ScrollTrigger for each section
      ScrollTrigger.create({
        trigger: thisTrigger,
        start: "bottom center",
        onEnter: (self) => {
          if (curIndex.current === i) {
            self.scroll(self.start + 1);
            if (masterTL.progress() < 1) scrollObserver.enable();
          }
        },
        markers: false, // Enable markers for debugging
      });
    });
  }, []);

  return (
    <div className="scroll-container" ref={containerRef}>
      {React.Children.map(children, (child, index) => (
        <div key={index} className="scroll-section">
          {child}
        </div>
      ))}
    </div>
  );
};

export default SwiperUp;
